// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.attr-tasks-panel[data-v-096bfc3e] { min-height: 60px; padding: 2px 0 6px;\n}\n.atp-empty[data-v-096bfc3e] { padding: 14px 8px; color: var(--text-color-secondary, #6b7280); font-size: 12px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
